import {lazyRegister} from "@core/lazyRegister";

type AllowType = string | number | boolean;

lazyRegister.filter('inArray', function () {
    return function (items: object[], arrayToCheck: AllowType[], key: string, allowEmpty: boolean = true): object[] {
        if (!arrayToCheck || !Array.isArray(arrayToCheck) || allowEmpty && arrayToCheck.length === 0) {
            return items;
        }
        return items.filter(function (item) {
            const property: AllowType | AllowType[] = item[key];
            if (Array.isArray(property)) {
                return arrayToCheck.some(x => property.some(y => y == x));
            }

            return arrayToCheck.indexOf(property) > -1;
        });
    };
});
